// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UnitList_unit-list__OrgPM {
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 40px;
}
.UnitList_unit-list__OrgPM .UnitList_results__nGA\\+s {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  align-self: stretch;
  overflow: hidden;
}
.UnitList_unit-list__OrgPM .UnitList_results__header__7-MqB {
  display: flex;
  padding: 0px 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  align-self: stretch;
}
.UnitList_unit-list__OrgPM .UnitList_results__body__4nVSt {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
}
.UnitList_unit-list__OrgPM .UnitList_results--title__xIx70 {
  text-align: center;
  color: var(--accent-color);
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.UnitList_unit-list__OrgPM .UnitList_results--description__K3Ey\\+ {
  color: var(--grey-text);
  text-align: center;
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.UnitList_unit-list__OrgPM .UnitList_results--controller__lcTGo {
  display: flex;
  padding: 0px 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}
.UnitList_unit-list__OrgPM .UnitList_results--controller__right__if\\+l5 {
  display: flex;
  align-items: center;
  gap: 8px;
}
.UnitList_unit-list__OrgPM .UnitList_right-section__lvKdP {
  max-width: 300px;
  width: 100%;
}
.UnitList_unit-list__OrgPM .UnitList_card__qndb1 {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 16px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.UnitList_unit-list__OrgPM .UnitList_card__qndb1:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(30, 58, 95, 0.1);
}
@media only screen and (max-width: 900px) {
  .UnitList_unit-list__OrgPM {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .UnitList_unit-list__OrgPM .UnitList_search-filters__-pStH {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 20px;
    width: 100%;
  }
  .UnitList_unit-list__OrgPM .UnitList_search-filters__-pStH .UnitList_search-mobile__Cy8Uy {
    width: 85%;
    display: block;
  }
  .UnitList_unit-list__OrgPM .UnitList_filters-results__nhJlW {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .UnitList_unit-list__OrgPM .UnitList_filters-results__nhJlW .UnitList_results__nGA\\+s {
    width: 100%;
  }
  .UnitList_unit-list__OrgPM .UnitList_filters-results__nhJlW .UnitList_results--title__xIx70 {
    font-size: 20px;
  }
  .UnitList_unit-list__OrgPM .UnitList_right-section__lvKdP {
    max-width: initial;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/UnitList/UnitList.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;AACF;AACE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AACI;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AACN;AAEI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAAN;AAGI;EACE,kBAAA;EACA,0BAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AADN;AAII;EACE,uBAAA;EACA,kBAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAFN;AAKI;EACE,aAAA;EACA,iBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAHN;AAKM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAHR;AAQE;EACE,gBAAA;EACA,WAAA;AANJ;AASE;EACE,oCAAA;EACA,2BAAA;EACA,mCAAA;EACA,0CAAA;EACA,mBAAA;EACA,iDAAA;AAPJ;AASI;EACE,2BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mCAAA;AAPN;AAWE;EAzFF;IA0FI,aAAA;IACA,sBAAA;IACA,uBAAA;EARF;EAUE;IACE,aAAA;IACA,8BAAA;IACA,QAAA;IACA,mBAAA;IACA,WAAA;EARJ;EAUI;IACE,UAAA;IACA,cAAA;EARN;EAYE;IACE,WAAA;IACA,aAAA;IACA,sBAAA;IACA,uBAAA;EAVJ;EAYI;IACE,WAAA;EAVN;EAYM;IACE,eAAA;EAVR;EAeE;IACE,kBAAA;EAbJ;AACF","sourcesContent":[".unit-list {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  gap: 40px;\n\n  .results {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 40px;\n    align-self: stretch;\n    overflow: hidden;\n\n    &__header {\n      display: flex;\n      padding: 0px 40px;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      gap: 12px;\n      align-self: stretch;\n    }\n\n    &__body {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 16px;\n      align-self: stretch;\n    }\n\n    &--title {\n      text-align: center;\n      color: var(--accent-color);\n      font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n      font-size: 24px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n    }\n\n    &--description {\n      color: var(--grey-text);\n      text-align: center;\n      font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n    }\n\n    &--controller {\n      display: flex;\n      padding: 0px 16px;\n      justify-content: space-between;\n      align-items: center;\n      align-self: stretch;\n\n      &__right {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n      }\n    }\n  }\n\n  .right-section {\n    max-width: 300px;\n    width: 100%;\n  }\n\n  .card {\n    background: rgba(255, 255, 255, 0.7);\n    backdrop-filter: blur(10px);\n    -webkit-backdrop-filter: blur(10px);\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    border-radius: 16px;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n\n    &:hover {\n      transform: translateY(-4px);\n      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n      background: rgba(255, 255, 255, 0.9);\n      border-color: rgba(30, 58, 95, 0.1);\n    }\n  }\n\n  @media only screen and (max-width: 900px) {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n    .search-filters {\n      display: flex;\n      justify-content: space-between;\n      gap: 8px;\n      margin-bottom: 20px;\n      width: 100%;\n\n      .search-mobile {\n        width: 85%;\n        display: block;\n      }\n    }\n\n    .filters-results {\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n\n      .results {\n        width: 100%;\n\n        &--title {\n          font-size: 20px;\n        }\n      }\n    }\n\n    .right-section {\n      max-width: initial;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"unit-list": `UnitList_unit-list__OrgPM`,
	"results": `UnitList_results__nGA+s`,
	"results__header": `UnitList_results__header__7-MqB`,
	"results__body": `UnitList_results__body__4nVSt`,
	"results--title": `UnitList_results--title__xIx70`,
	"results--description": `UnitList_results--description__K3Ey+`,
	"results--controller": `UnitList_results--controller__lcTGo`,
	"results--controller__right": `UnitList_results--controller__right__if+l5`,
	"right-section": `UnitList_right-section__lvKdP`,
	"card": `UnitList_card__qndb1`,
	"search-filters": `UnitList_search-filters__-pStH`,
	"search-mobile": `UnitList_search-mobile__Cy8Uy`,
	"filters-results": `UnitList_filters-results__nhJlW`
};
export default ___CSS_LOADER_EXPORT___;
